import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { Service, Booking, Venue } from './types';
import { timer, Subscription } from 'rxjs';
import { ScreeningDialogComponent } from './dialogs/screening/screening.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  uid = '';
  signedIn = false;
  signingIn = false;
  services: Service[] = [];
  myBookings: Booking[] = [];
  myBookingsWithScreeningOpen: Booking[] = [];
  myBookingsDictionary: Record<string, any> = {};
  myBookingsDictionaryLoaded = false;
  allBookingsDictionary: Record<string, any> = {};
  bookingSubscriptions: Record<string, boolean> = {};
  myBookingsSubscription = false;
  events: Event[] = [];
  constructor(
    public firestore: AngularFirestore,
    public authenticate: AngularFireAuth,
    public dialog: MatDialog
  ) {
    timer(2000, 3000).subscribe((t) => {
      this.checkMyBookingList();
    });
    this.authenticate.authState.subscribe((user) => {
      if (user) {
        console.log('Signed in');
        this.uid = user.uid;
        this.loadServices();
        //this.addService();
        //this.addEvent();
        this.loadEvents();
      } else {
        this.authenticate.signInAnonymously();
      }
    });
  }

  addEvent() {
    const event1: Event = {
      title: 'Juventus Lofprysingsaand',
      description:
        'Lofprysingsaand. Hoërskool katkisante, jong werkendes, studente. 12 September.',
      visible: true,
      time: new Date(2021, 8, 12).getTime(),
      imageUrl:
        'https://firebasestorage.googleapis.com/v0/b/reformedcentral-139c1.appspot.com/o/juventusLofprysing.jpeg?alt=media&token=69bfb163-05dd-4788-b32b-3ef6f78201cb',
    };
    const event2: Event = {
      title: 'Blok C WhatsApp Groep',
      description:
        'Kommunikasie en inligting vir gesinne met kinders op skool 👪',
      visible: true,
      time: new Date(2021, 8, 30).getTime(),
      link: {
        title: 'Sluit aan by die groep',
        url: 'https://chat.whatsapp.com/Fu2F8PyEDHj3d0QW1rnX7b',
      },
      imageUrl:
        'https://firebasestorage.googleapis.com/v0/b/reformedcentral-139c1.appspot.com/o/blockCWhatsApp.jpg?alt=media&token=5a654ebf-bd33-44ee-afd5-785c5a31f5fb',
    };
    this.firestore.collection('events').add(event1);
    this.firestore.collection('events').add(event2);
  }

  addService() {
    const s1: Service = {
      date: new Date(2021, 8, 26, 9, 30).getTime(),
      description: 'Oggenddiens',
      id: 'xxx',
      link: 'youtube.com',
      venues: [
        { description: 'Kerkgebou ⛪', max: 40, taken: 0 },
        { description: 'Moederskamer 👶', max: 10, taken: 0 },
      ],
    };
    this.firestore
      .collection('services')
      .add(s1)
      .then((d) => {
        this.firestore.collection('services').doc(d.id).update({ id: d.id });
      });
    const s2: Service = {
      date: new Date(2021, 8, 26, 18, 30).getTime(),
      description: 'Aanddiens',
      id: 'xxx',
      link: 'youtube.com',
      venues: [
        { description: 'Kerkgebou ⛪', max: 40, taken: 0 },
        { description: 'Moederskamer 👶', max: 10, taken: 0 },
      ],
    };
    this.firestore
      .collection('services')
      .add(s2)
      .then((d) => {
        this.firestore.collection('services').doc(d.id).update({ id: d.id });
      });
  }

  loadEvents() {
    this.firestore
      .collection('events', (ref) =>
        ref
          .where('visible', '==', true)
          .where('time', '>=', new Date().getTime())
          .orderBy('time', 'asc')
      )
      .snapshotChanges()
      .subscribe((events) => {
        this.events = [];
        events.forEach((event) => {
          const eventData = event.payload.doc.data() as Event;
          this.events.push(eventData);
        });
      });
  }

  loadServices() {
    this.firestore
      .collection('services', (ref) =>
        ref
          .where('date', '>=', new Date().getTime() - 60000 * 60)
          .orderBy('date', 'asc')
      )
      .snapshotChanges()
      .subscribe((services) => {
        this.services = [];
        services.forEach((service) => {
          const serviceData = service.payload.doc.data() as Service;
          this.allBookingsDictionary[serviceData.id] = {};
          serviceData.venues.forEach((venue) => {
            this.allBookingsDictionary[serviceData.id][venue.description] =
              venue.taken;
          });
          serviceData.canBook = true;
          this.services.push(serviceData);
          if (
            !this.bookingSubscriptions.hasOwnProperty(service.payload.doc.id)
          ) {
            this.bookingSubscriptions[service.payload.doc.id] = true;
            this.subscribeToBookings(service.payload.doc.id, serviceData);
          } else {
            this.countMyBookings();
          }
        });
        if (!this.myBookingsSubscription) {
          this.loadYourBookings(this.uid);
          this.myBookingsSubscription = true;
        }
      });
  }

  loadYourBookings(uid: string) {
    this.firestore
      .collection('bookings', (ref) =>
        ref
          .where('uid', '==', uid)
          .where('serviceTime', '>=', new Date().getTime() - 60000 * 60)
      )
      .valueChanges()
      .subscribe((bookings) => {
        this.myBookings = [];
        this.myBookingsWithScreeningOpen = [];
        bookings.forEach((booking) => {
          const b = booking as Booking;
          b.canHealthScreen = this.canHealthScreen(b);
          this.myBookings.push(b);
          if (b.canHealthScreen) {
            this.myBookingsWithScreeningOpen.push(b);
          }
        });
        this.countMyBookings();
      });
  }

  checkMyBookingList() {
    this.myBookings.forEach((booking) => {
      if (this.canHealthScreen(booking)) {
        this.myBookings[this.myBookings.indexOf(booking)].canHealthScreen =
          true;
      }
    });
  }

  canHealthScreen(booking: Booking) {
    const service = this.services.find(
      (service) => service.id === booking.serviceId
    );
    if (service && service.date - new Date().getTime() < 1000 * 60 * 60 * 4) {
      return true;
    } else {
      return false;
    }
  }

  screen(booking: Booking) {
    if (this.canHealthScreen(booking)) {
      if (!booking.healthScreening) {
        this.dialog
          .open(ScreeningDialogComponent, {
            data: booking,
            width: '90%',
          })
          .afterClosed();
      } else {
        alert('Klaar gedoen');
      }
    } else {
      alert('Nog nie beskikbaar nie');
    }
  }
  countMyBookings() {
    this.cleanMyBookingsDictionary();
    this.myBookings.forEach((booking) => {
      const bookingData = booking as Booking;
      this.myBookingsDictionary[bookingData.serviceId][
        bookingData.venueDescription
      ] += 1;
    });
  }

  cleanMyBookingsDictionary() {
    this.services.forEach((service) => {
      this.myBookingsDictionary[service.id] = {};
      service.venues.forEach((venue) => {
        this.myBookingsDictionary[service.id][venue.description] = 0;
      });
    });
    this.myBookingsDictionaryLoaded = true;
  }

  cleanAllBookingsDictionary() {
    for (const service in this.allBookingsDictionary) {
      for (const venue in this.allBookingsDictionary[service]) {
        this.allBookingsDictionary[service][venue] = 0;
      }
    }
  }

  subscribeToBookings(serviceId: string, service: Service) {
    this.firestore
      .collection('bookings', (ref) => ref.where('serviceId', '==', serviceId))
      .valueChanges()
      .subscribe((bookings) => {
        let bookingCounter: Record<string, number> = {};
        if (bookings.length > 0) {
          let serviceId = '';
          bookings.forEach((booking) => {
            const bookingData = booking as Booking;
            serviceId = bookingData.serviceId;
            if (!bookingCounter.hasOwnProperty(bookingData.venueDescription)) {
              bookingCounter[bookingData.venueDescription] = 1;
            } else {
              bookingCounter[bookingData.venueDescription] += 1;
            }
          });
        }
        service.venues.forEach((venue) => {
          if (!bookingCounter.hasOwnProperty(venue.description)) {
            bookingCounter[venue.description] = 0;
          }
        });
        this.updateServiceVenues(serviceId, bookingCounter);
      });
  }

  updateServiceVenues(
    serviceId: string,
    bookingCounter: Record<string, number>
  ) {
    this.services.forEach((service) => {
      if (service.id === serviceId) {
        const newVenues: Venue[] = [];
        service.venues.forEach((venue) => {
          if (bookingCounter.hasOwnProperty(venue.description)) {
            venue.taken = bookingCounter[venue.description];
            newVenues.push(venue);
          } else {
            newVenues.push(venue);
          }
        });
        this.firestore
          .collection('services')
          .doc(serviceId)
          .update({ venues: newVenues })
          .then((d) => {});
      }
    });
  }
}

interface Event {
  title: string;
  link?: Link;
  imageUrl?: string;
  description?: string;
  time: number;
  visible: boolean;
}

interface Link {
  url: string;
  title: string;
}
